import { useContext } from 'react';
import DashboardContext, { DashboardContextData } from '../context';

export const useDashboardContext = (): DashboardContextData => useContext(DashboardContext);
